import { AiFillHtml5 } from "react-icons/ai";
import { DiReact, DiCss3 } from "react-icons/di";
import {
  SiTypescript,
  SiNextdotjs,
  SiPython,
  SiGooglecloud,
  SiNodedotjs,
  SiCplusplus,
  SiExpress,
  SiDocker,
  SiGithubactions,
  SiAmazonaws,
  SiMongodb,
  SiElasticstack,
  SiPrometheus,
  SiGrafana,
  SiSplunk,
  SiDatadog,
  SiGit,
  SiTailwindcss,
} from "react-icons/si";
import { IoLogoJavascript } from "react-icons/io";
import Icon from "../../../UI/Icon";
import SkillData from "./skillData";
import { FaAws } from "react-icons/fa";
const skillList = {
  languages: (
    <SkillData>
      <div className="skill-data__icons">
        <Icon>
          <IoLogoJavascript />
        </Icon>
        <Icon>
          <SiTypescript />
        </Icon>
        <Icon>
          <SiPython />
        </Icon>
        <Icon>
          <SiCplusplus />
        </Icon>
      </div>
      <div className="skill-data_skill-names">
        <ul>
          <li>JavaScript</li>
          <li>Python Basic</li>
          <li>C++</li>
        </ul>
      </div>
    </SkillData>
  ),
  frontend: (
    <SkillData>
      <div className="skill-data__icons">
        <Icon>
          <DiReact />
        </Icon>
        <Icon>
          <SiTypescript />
        </Icon>
        <Icon>
          <SiNextdotjs />
        </Icon>
        <Icon>
          <AiFillHtml5 />
        </Icon>
        <Icon>
          <DiCss3 />
        </Icon>
        <Icon>
          <SiTailwindcss />
        </Icon>
      </div>
      <div className="skill-data_skill-names">
        <ul>
          <li>React.js</li>
          <li>Next.js</li>
          <li>TypeScript</li>
        </ul>
        <ul>
          <li>HTML</li>
          <li>CSS</li>
          <li>Tailwind Css</li>
        </ul>
      </div>
    </SkillData>
  ),
  backend: (
    <SkillData>
      <div className="skill-data__icons">
        <Icon>
          <SiNodedotjs />
        </Icon>
        <Icon>
          <SiExpress />
        </Icon>
      </div>
      <div className="skill-data_skill-names">
        <ul>
          <li>Node.js</li>
          <li>REST APIs</li>
          <li>Express.js</li>
        </ul>
      </div>
    </SkillData>
  ),
  devops: (
    <SkillData>
      <div className="skill-data__icons">
        <Icon>
          <FaAws />
        </Icon>
        <Icon>
          <SiDocker />
        </Icon>
        {/* <Icon>
          <SiKubernetes />
        </Icon> */}
        {/* <Icon>
          <SiHelm />
        </Icon> */}
        {/* <Icon>
          <SiTerraform />
        </Icon> */}
        {/* <Icon>
          <SiAnsible />
        </Icon> */}
        {/* <Icon>
          <SiPulumi />
        </Icon> */}
        <Icon>
          <SiGithubactions />
        </Icon>
        {/* <Icon>
          <SiJenkins />
        </Icon> */}
        <Icon>
          <SiGit />
        </Icon>
        {/* <Icon>
          <SiLinux />
        </Icon> */}
        {/* <Icon>
          <SiVault />
        </Icon> */}
      </div>
      <div className="skill-data_skill-names">
        <ul>
          <li>AWS</li>
          <li>Docker</li>
        </ul>
        <ul>
          <li>Git</li>
          <li>Github Actions</li>
        </ul>
      </div>
    </SkillData>
  ),
  csp: (
    <SkillData>
      <div className="skill-data__icons">
        <Icon>
          <SiGooglecloud />
        </Icon>
        <Icon>
          <SiAmazonaws />
        </Icon>
      </div>
      <div className="skill-data_skill-names">
        <ul>
          <li>Google Cloud Platform</li>
          <li>AWS</li>
        </ul>
      </div>
    </SkillData>
  ),
  monitoring: (
    <SkillData>
      <div className="skill-data__icons">
        <Icon>
          <SiElasticstack />
        </Icon>
        <Icon>
          <SiGrafana />
        </Icon>
        <Icon>
          <SiPrometheus />
        </Icon>
        <Icon>
          <SiSplunk />
        </Icon>
        <Icon>
          <SiDatadog />
        </Icon>
      </div>
      <div className="skill-data_skill-names">
        <ul>
          <li>Elastic Stack: ElasticSearch, Logstash, Kibana</li>
          <li>Prometheus + Grafana</li>
          <li>Splunk, Datadog</li>
        </ul>
      </div>
    </SkillData>
  ),
  db: (
    <SkillData>
      <div className="skill-data__icons">
        {/* <Icon>
          <SiMysql />
        </Icon> */}
        {/* <Icon>
          <SiPostgresql />
        </Icon> */}
        <Icon>
          <SiMongodb />
        </Icon>
        {/* <Icon>
          <SiFirebase />
        </Icon> */}
      </div>
      <div className="skill-data_skill-names">
        <ul>
          <li>NoSQL Databases: MongoDB</li>
        </ul>
      </div>
    </SkillData>
  ),
};
export default skillList;
